import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "jspdf-autotable";

import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Loader from "../../components/loader";

function LedgerReport() {
  const [loader, setLoader] = useState(false);
  const [orderData, setData] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [date, setDate] = useState(today);
  const [filterdData, setFilteredData] = useState([]);
  const [dealerFilter, setDealerFilter] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRoutes, setSelectedRoutes] = useState(["all"]);
  const [allRoutes, setAllRoutes] = useState([]);
  console.log(selectedRoutes);

  //   const filterDealer = () => {
  //     const filterData = orderData?.filter((order) => {
  //       let dealerMatch = true;
  //       let routeMatch = true;

  //       if (dealerFilter) {
  //         dealerMatch = order?.dealerData?.dealer
  //           ?.toLowerCase()
  //           .includes(dealerFilter.toLowerCase());
  //       }

  //       if (selectedRoutes) {
  //         if (typeof selectedRoutes === "string") {
  //           routeMatch = order?.routes
  //             ?.toLowerCase()
  //             .includes(selectedRoutes.toLowerCase());
  //         } else if (Array.isArray(selectedRoutes) && selectedRoutes.length > 0) {
  //           routeMatch = selectedRoutes.some((route) =>
  //             order?.routes?.toLowerCase().includes(route.toLowerCase())
  //           );
  //         }else {
  //       // ✅ Case 4: Empty array → nothing to filter (no match)
  //       routeMatch = false;
  //     }
  //       }

  //       return dealerMatch && routeMatch;
  //     });

  //     console.log("filterData", filterData);
  //     setFilteredData(filterData);
  //   };

  const filterDealer = () => {
    const filterData = orderData?.filter((order) => {
      let dealerMatch = true;
      let routeMatch = true;

      // ✅ Dealer filter
      if (dealerFilter) {
        dealerMatch = order?.dealerData?.dealer
          ?.toLowerCase()
          .includes(dealerFilter.toLowerCase());
      }

      // ✅ Route filter
      if (selectedRoutes) {
        if (typeof selectedRoutes === "string") {
          // Single route (string)
          routeMatch = order?.routes
            ?.toLowerCase()
            .includes(selectedRoutes.toLowerCase());
        } else if (Array.isArray(selectedRoutes)) {
          if (selectedRoutes.includes("all")) {
            // ✅ Case: ['all'] → show everything
            routeMatch = true;
          } else if (selectedRoutes.length > 0) {
            // ✅ Case: one or more specific routes
            routeMatch = selectedRoutes.some((route) =>
              order?.routes?.toLowerCase().includes(route.toLowerCase())
            );
          } else {
            // ✅ Case: Empty array → nothing matches
            routeMatch = false;
          }
        }
      }

      return dealerMatch && routeMatch;
    });

    console.log("filterData", filterData);
    setFilteredData(filterData);
  };

  useEffect(() => {
    filterDealer();
  }, [dealerFilter, selectedRoutes]);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleRouteSelection = (route) => {
    if (route === "all") {
      if (selectedRoutes.includes("all")) {
        setSelectedRoutes([]);
      } else {
        setSelectedRoutes(["all"]);
      }
    } else {
      if (selectedRoutes.includes(route)) {
        const updatedRoutes = selectedRoutes.filter((r) => r !== route);
        if (updatedRoutes.length === 0) {
          setSelectedRoutes(["all"]);
        } else {
          setSelectedRoutes(updatedRoutes.filter((r) => r !== "all"));
          filterDealer();
        }
      } else {
        const updatedRoutes = [
          ...selectedRoutes.filter((r) => r !== "all"),
          route,
        ];
        setSelectedRoutes(updatedRoutes);
        filterDealer();
      }
    }
  };

  const isRouteSelected = (route) => {
    return selectedRoutes.includes("all") || selectedRoutes.includes(route);
  };

  const formatDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${newDate.getFullYear()}-${String(
      newDate.getMonth() + 1
    ).padStart(2, "0")}-${String(newDate.getDate()).padStart(2, "0")}`;
    return formattedDate;
  };

  const formatViewDate = (date) => {
    const newDate = new Date(date);
    if (isNaN(newDate)) {
      console.error("Invalid date format");
      return;
    }

    const formattedDate = `${String(newDate.getDate()).padStart(
      2,
      "0"
    )}-${String(newDate.getMonth() + 1).padStart(
      2,
      "0"
    )}-${newDate.getFullYear()}`;
    return formattedDate;
  };

  const getData = async () => {
    setLoader(true);
    try {
      const response = await axios.post(
        "https://api.trucoo.in/invoice/report/",
        { date },
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": "erpTrucoo",
          },
        }
      );

      console.log(response.data);

      if (response.data.status === "success") {
        const routes = [
          ...new Set(
            response.data.data
              .map((order) => order.routes || "")
              .filter((r) => r)
          ),
        ];

        setAllRoutes(routes);
        console.log(routes);

        setData(response.data.data);
        setFilteredData(response.data.data);
      } else {
        console.log("Error fetching data");
        setData([]);
      }
    } catch (error) {
      console.error("Error:", error.response || error.message);
      setData([]);
    }
    setLoader(false);
  };

  useEffect(() => {
    getData();
  }, [date]);

  const getFiscalYearLabel = (date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    if (month < 3) {
      return `${(year - 1).toString().slice(-2)}-${year.toString().slice(-2)}`;
    } else {
      return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
    }
  };

  const getGSTItem = (orderDatails, dealerDetails, type, product) => {
    const gstType = dealerDetails?.gstType;

    if (gstType === type && product === "milk") {
      let total = 0;

      orderDatails?.forEach((item) => {
        if (item?.itemType === "milk") {
          if (parseFloat(item?.itemGst) > 0) {
            const price = parseFloat(item.itemPrice);
            const gst = parseFloat(item.itemGst);
            const productGst = parseFloat(price - price / (1 + gst / 100));
            const productPrice = parseFloat(price - productGst);
            total +=
              parseFloat(
                parseFloat(productPrice) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ) || 0;
          } else {
            const price = parseFloat(item.itemPrice);
            total +=
              parseFloat(
                parseFloat(price) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ) || 0;
          }
        }
      });

      if (total > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else if (gstType === type && product === "curd") {
      let total = 0;
      orderDatails?.forEach((item) => {
        if (item?.itemType === "curd") {
          if (parseFloat(item?.itemGst) > 0) {
            const price = parseFloat(item.itemPrice);
            const gst = parseFloat(item.itemGst);
            const productGst = parseFloat(price - price / (1 + gst / 100));
            const productPrice = parseFloat(price - productGst).toFixed(2);
            total +=
              parseFloat(productPrice) *
                (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(
                  2
                ) || 0;
          } else {
            const price = parseFloat(item.itemPrice);
            total +=
              parseFloat(
                parseFloat(price) *
                  parseFloat(item?.qty) *
                  parseFloat(item?.itemGrade)
              ).toFixed(2) || 0;
          }
        }
      });

      if (parseFloat(total) > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getGstTotal = (orderDatails, dealerDetails, type) => {
    const gstType = dealerDetails?.gstType;

    if (gstType === type) {
      let total = 0;
      orderDatails?.forEach((item) => {
        if (item?.itemGst > 0) {
          const price = parseFloat(item.itemPrice);
          const gst = parseFloat(item.itemGst);
          const productGst = parseFloat(price - price / (1 + gst / 100));
          const productPrice = parseFloat(price - productGst).toFixed(2);
          total +=
            parseFloat(productPrice) *
              (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(
                2
              ) || 0;
        }
      });

      if (parseFloat(total) > 0) {
        return parseFloat(total).toFixed(2);
      } else {
        return "";
      }
    } else {
      return "";
    }
  };

  const getTotal = (orderDatails) => {
    let total = 0;
    orderDatails?.forEach((item) => {
      const price = parseFloat(item.itemPrice);
      const gst = parseFloat(item.itemGst);
      const productGst = parseFloat(price - price / (1 + gst / 100)) || 0;
      const productPrice = parseFloat(price - productGst).toFixed(2);
      total +=
        parseFloat(productPrice) *
          (parseFloat(item?.qty) * parseFloat(item?.itemGrade)).toFixed(2) || 0;
    });

    if (parseFloat(total) > 0) {
      return parseFloat(total).toFixed(2);
    } else {
      return "";
    }
  };

  // const getGrandTotal = (orderDatails) => {
  //     let total = 0;
  //     orderDatails?.forEach((item) => {
  //         const price = parseFloat(item.itemPrice);
  //         const gst = parseFloat(item.itemGst);
  //         const productGst = parseFloat(price - ( price / (1+ gst/100) )) || 0;
  //         const productPrice = parseFloat(price - productGst);
  //         total += parseFloat(productPrice) * (parseFloat(item?.qty) * parseFloat(item?.itemGrade)) || 0;
  //     });

  //     if (parseFloat(total) > 0) {
  //         return parseFloat(total).toFixed(2);
  //     }else{
  //         return '';
  //     }
  // };

  const getWeight = (type, orderDatails, discountData) => {
    let totalWeight = 0;
    orderDatails?.forEach((item) => {
      const discount = JSON.parse(discountData)?.filter(
        (items) => items.item === item.itemId
      )[0];

      let dicsCrates = 0;

      if (discount?.type === "grade" && discount?.discount === "packet") {
        dicsCrates =
          (parseFloat(discount.value) * parseFloat(item?.qty)) /
          parseFloat(item?.itemGrade);
      }

      if (item?.itemType === type) {
        totalWeight +=
          parseFloat(item?.itemWeight / 1000) *
            ((parseFloat(item?.qty) + parseFloat(dicsCrates)) *
              parseFloat(item?.itemGrade)) || 0;
      }
    });
    return totalWeight.toFixed(2);
  };

  // const getDidcCrates = (discountData, orderData) => {

  //     let crates = 0;
  //     JSON.parse(discountData)?.forEach(items => {
  //         const product = orderData?.filter(item => item?.itemId === items?.item)[0];

  //         if(items?.type === 'grade' && items?.discount === 'packet'){
  //             crates += parseFloat(items.value) * parseFloat(product?.qty) / parseFloat(product?.itemGrade)
  //         }
  //     });

  //     return crates;
  // };

  const exportToExcel = () => {
    const ws = XLSX.utils.table_to_sheet(
      document.getElementById("printableArea")
    );
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Daily Sales Report");
    XLSX.writeFile(wb, `Daily_Sales_Report_${formatDate(date)}.xlsx`);
  };

  let igstMilkTotal = 0;
  let sgstMilkTotal = 0;
  let igstCurdTotal = 0;
  let sgstCurdTotal = 0;
  let netTotTotal = 0;
  let iGstTotal = 0;
  let sGstTotal = 0;
  let dicsTotal = 0;
  let grandTotTotal = 0;
  let milkWeightTotal = 0;
  let curdWeightTotal = 0;
  let roundOffTotal = 0;

  return (
    <>
      {loader && <Loader />}
      <Header />
      <Sidebar />

      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="row">
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12">
                    <h4 className="box-title">Daily Sales Report</h4>
                    <p className="mb-0 box-subtitle">Invoices</p>
                  </div>
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12"></div>
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12"></div>
                  <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12"></div>
                  <div className="d-flex flex-wrap align-items-center gap-2 justify-content-end">
                    <input
                      type="date"
                      value={formatDate(date)}
                      onChange={(e) => setDate(e.target.value)}
                      className="form-control"
                      style={{ maxWidth: 200 }}
                    />

                    <input
                      className="form-control"
                      value={dealerFilter}
                      onChange={(e) => setDealerFilter(e.target.value)}
                      placeholder="Enter Dealer Name..."
                      style={{ maxWidth: 200 }}
                    />

                    <div className="col-xxl-2 col-xl-2 col-lg-2 col-md-6 col-12">
                      <div className="dropdown">
                        <button
                          className="form-control text-start"
                          onClick={toggleDropdown}
                          style={{ textAlign: "left" }}
                        >
                          {selectedRoutes.includes("all")
                            ? "All Routes"
                            : `${selectedRoutes.length} Routes Selected`}
                        </button>
                        {isOpen && (
                          <div
                            className="dropdown-menu show"
                            style={{ minWidth: "250px", padding: "8px" }}
                          >
                            <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                              <strong>Select Routes</strong>
                              <button
                                className="btn btn-sm btn-light"
                                onClick={toggleDropdown}
                              >
                                ×
                              </button>
                            </div>

                            <div className="dropdown-item py-1">
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: "10px",
                                  }}
                                  id="allRoutesCheckbox"
                                  value="all"
                                  checked={selectedRoutes.includes("all")}
                                  onChange={() => handleRouteSelection("all")}
                                />
                                <label
                                  className="form-check-label ms-3"
                                  htmlFor="allRoutesCheckbox"
                                  style={{ paddingLeft: "24px" }}
                                >
                                  All Routes
                                </label>
                              </div>
                            </div>

                            {allRoutes.map((route) => (
                              <div key={route} className="dropdown-item py-1">
                                <div className="form-check d-flex align-items-center">
                                  <input
                                    type="checkbox"
                                    className="form-check-input"
                                    style={{
                                      opacity: 0,
                                      position: "absolute",
                                      left: "10px",
                                    }}
                                    id={`routeCheckbox-${route}`}
                                    value={route}
                                    checked={isRouteSelected(route)}
                                    onChange={() => handleRouteSelection(route)}
                                  />
                                  <label
                                    className="form-check-label ms-3"
                                    htmlFor={`routeCheckbox-${route}`}
                                    style={{ paddingLeft: "24px" }}
                                  >
                                    {route}
                                  </label>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>

                    <button
                      className="btn btn-sm btn-success"
                      onClick={exportToExcel}
                    >
                      <i className="fa fa-download"></i> Excel
                    </button>
                  </div>
                </div>
              </div>

              <div className="box-body">
                <div
                  className="table-responsive"
                  style={{
                    width: "100%",
                    height: "calc(100vh - 290px)",
                    overflow: "auto",
                    padding: "0 10px 10px 10px",
                  }}
                >
                  <table
                    style={{ whiteSpace: "nowrap" }}
                    className="table-sm table-bordered nowrap fs-10"
                    id="printableArea"
                    width="100%"
                  >
                    <thead>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <th rowspan="2">Invoice Date</th>
                        <th rowspan="2">Invoice No.</th>
                        <th rowspan="2">Dealer</th>
                        <th rowspan="2">Route</th>
                        <th rowspan="2">GST No.</th>
                        <th colSpan={3}>MILK Sales</th>
                        <th colSpan={3}>CURD Sales</th>
                        <th rowspan="2">Net Total</th>
                        <th rowspan="2">IGST</th>
                        <th rowspan="2">CGST</th>
                        <th rowspan="2">SGST</th>
                        <th rowspan="2">Trade Discount</th>
                        <th rowspan="2">Round-Off</th>
                        <th rowspan="2">Invoice Amount</th>
                      </tr>
                      <tr
                        className="text-dark text-center"
                        style={{
                          position: "sticky",
                          top: "25px",
                          zIndex: 1,
                          backgroundColor: "#f8f9fa",
                        }}
                      >
                        <th>LTR</th>
                        <th>SGST SALES</th>
                        <th>IGST SALES</th>
                        <th>KG</th>
                        <th>SGST SALES</th>
                        <th>IGST SALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filterdData && filterdData.length > 0 ? (
                        // Show filtered data
                        <>
                          {filterdData.map((item, index) => {
                            const iGSTMilk = getGSTItem(
                              item?.orderData,
                              item?.dealerData,
                              "IGST",
                              "milk"
                            );
                            const iGSTCurd = getGSTItem(
                              item?.orderData,
                              item?.dealerData,
                              "IGST",
                              "curd"
                            );
                            const sGSTMilk = getGSTItem(
                              item?.orderData,
                              item?.dealerData,
                              "SGST",
                              "milk"
                            );
                            const sGSTCurd = getGSTItem(
                              item?.orderData,
                              item?.dealerData,
                              "SGST",
                              "curd"
                            );
                            const sgstTotal = parseFloat(
                              getGstTotal(
                                item?.orderData,
                                item?.dealerData,
                                "SGST"
                              ) || 0
                            );
                            const igstTotal = parseFloat(
                              getGstTotal(
                                item?.orderData,
                                item?.dealerData,
                                "IGST"
                              ) || 0
                            );
                            const discount = parseFloat(item?.discount || 0);

                            const milkWeight = getWeight(
                              "milk",
                              item?.orderData,
                              item?.discountData
                            );
                            const curdWeight = getWeight(
                              "curd",
                              item?.orderData,
                              item?.discountData
                            );

                            const orderTotal = parseFloat(
                              getTotal(item?.orderData)
                            );
                            const sgst = (sgstTotal * 0.025).toFixed(2);
                            const igst = (igstTotal * 0.05).toFixed(2);
                            const totalPayment =
                              parseFloat(orderTotal) +
                              parseFloat(sgst) +
                              parseFloat(igst);

                            const netAmount = totalPayment - discount;
                            const finalPayment = Math.round(netAmount);
                            const roundOff = (finalPayment - netAmount).toFixed(
                              2
                            );

                            igstMilkTotal += parseFloat(iGSTMilk || 0);
                            sgstMilkTotal += parseFloat(sGSTMilk || 0);
                            igstCurdTotal += parseFloat(iGSTCurd || 0);
                            sgstCurdTotal += parseFloat(sGSTCurd || 0);
                            netTotTotal += parseFloat(orderTotal || 0);
                            iGstTotal += parseFloat(igst || 0);
                            sGstTotal += parseFloat(sgst || 0);
                            dicsTotal += parseFloat(discount || 0);
                            grandTotTotal += parseFloat(finalPayment || 0);
                            milkWeightTotal += parseFloat(milkWeight || 0);
                            curdWeightTotal += parseFloat(curdWeight || 0);
                            roundOffTotal += parseFloat(roundOff || 0);
                            return (
                              <tr key={index}>
                                <td data-t="s">{formatViewDate(item?.date)}</td>
                                <td>{`TRC/${item?.invoiceId}/${getFiscalYearLabel(
                                  new Date(item?.date)
                                )}`}</td>
                                <td>{item?.dealerData?.dealer}</td>
                                <td>{item?.routes}</td>
                                <td>{item?.dealerData?.gst}</td>
                                <td className="text-end">
                                  {milkWeight > 0
                                    ? Number(milkWeight).toFixed(2)
                                    : ""}
                                </td>
                                <td className="text-end">{sGSTMilk}</td>
                                <td className="text-end">{iGSTMilk}</td>
                                <td className="text-end">
                                  {curdWeight > 0
                                    ? Number(curdWeight).toFixed(2)
                                    : ""}
                                </td>
                                <td className="text-end">{sGSTCurd}</td>
                                <td className="text-end">{iGSTCurd}</td>
                                <td className="text-end">
                                  {orderTotal.toFixed(2)}
                                </td>
                                <td className="text-end">
                                  {igstTotal > 0 ? igst : ""}
                                </td>
                                <td className="text-end">
                                  {sgstTotal > 0 ? sgst : ""}
                                </td>
                                <td className="text-end">
                                  {sgstTotal > 0 ? sgst : ""}
                                </td>
                                <td className="text-end">
                                  {discount > 0 ? discount.toFixed(2) : ""}
                                </td>
                                <td className="text-end">
                                  {parseFloat(roundOff) !== 0
                                    ? parseFloat(roundOff).toFixed(2)
                                    : ""}
                                </td>
                                <td className="text-end">{finalPayment}</td>
                              </tr>
                            );
                          })}

                          <tr className="bg-light font-weight-bold">
                            <th colSpan="5" className="text-end">Total</th>
                            <th className="text-end">{milkWeightTotal.toFixed(2)}</th>
                            <th className="text-end">{sgstMilkTotal.toFixed(2)}</th>
                            <th className="text-end">{igstMilkTotal.toFixed(2)}</th>
                            <th className="text-end">{curdWeightTotal.toFixed(2)}</th>
                            <th className="text-end">{sgstCurdTotal.toFixed(2)}</th>
                            <th className="text-end">{igstCurdTotal.toFixed(2)}</th>
                            <th className="text-end">{netTotTotal.toFixed(2)}</th>
                            <th className="text-end">{iGstTotal.toFixed(2)}</th>
                            <th className="text-end">{sGstTotal.toFixed(2)}</th>
                            <th className="text-end">{sGstTotal.toFixed(2)}</th>
                            <th className="text-end">{dicsTotal.toFixed(2)}</th>
                            <th className="text-end">{parseFloat(roundOffTotal).toFixed(2)}</th>
                            <th className="text-end">{grandTotTotal.toFixed(2)}</th>
                          </tr>
                        </>
                      ): (
                        // Show this if no data
                        <tr>
                          <td colSpan="17" className="text-center">
                            No Data Available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* <Footer /> */}
    </>
  );
}

export default LedgerReport;
